import styled from 'styled-components';

interface TextProps {
    type: 'title' | 'subtitle' | 'large' | 'medium' | 'bold'
}

const Text = styled.span<TextProps>((props) => {
    let style = {};

    switch (props.type) {
        case 'title': {
            style = {
                fontSize: 18,
                fontFamily: 'Aspira Wide Demi',
                fontWeight: 500
            }
            break;
        }
        case 'subtitle': {
            style = {
                fontSize: 14,
                fontFamily: 'Aspira Demi',
                fontWeight: 900
            }
            break;
        }
        case 'large': {
            style = {
                fontSize: 16,
                fontFamily: 'Aspira Regular',
                fontWeight: 400
            }
            break;
        }
        case 'medium': {
            style = {
                fontSize: 14,
                fontFamily: 'Aspira Regular',
                fontWeight: 400
            }
            break;
        }
        case 'bold': {
            style = {
                fontSize: 14,
                fontFamily: 'Aspira Demi',
                fontWeight: 500
            }
            break
        }
        default: {
            break;
        }
    }

    return {
        fontFamily: 'Aspira Regular',
        color: '#414141',
        display: 'inline-flex',
        alignItems: 'center',
        ...style,
    }

});

export default Text;
